module.exports = __webpack_public_path__ + "img/2-white.a1b98c63.png";